export const BROADCAST_CHANNEL_NAME = 'meta_integration_channel';
